/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from "react";
import moment from 'moment';
import 'moment/locale/es';

const SpaceInfo = ({ data, fields }) => {
  moment.locale('es');
  const balance = { disposable: "Disponible", locked: "Bloqueado", total: "Total" }
  const [showPespay, setShowPespay] = useState(false);
  const [showDapp, setShowDapp] = useState(false);
  const [showSpace, setShowSpace] = useState(false);

  useEffect(() => {
    fields.in.indexOf('pespay') !== -1 ? setShowPespay(true) : setShowPespay(false)
    fields.in.indexOf('dapp') !== -1 ? setShowDapp(true) : setShowDapp(false)
    fields.in.indexOf('os_space') !== -1 ? setShowSpace(true) : setShowSpace(false)
  })

  const info = [
    { key: data.space.type === "7" ? "currency" : null, label: "Divisa", data: data.space.currency},
    { key: data.space.type === "7" ? "pusherChannel" : null, label: "Canal de Compra", data: data.space.pusherChannel},
    { key: data.space.type === "5" ? "name" : null, label: "Nombre", data: data.space.name},
    { key: data.space.type !== "7" ? "level" : null, label: "Nivel de cuenta", data: data.space.level},
    { key: data.space.type !== "5" && data.space.type !== "7" ? "clabe" : null, label: "CLABE", data: data.space.clabe},
    { key: data.space.type !== "5" && data.space.type !== "7" && data.space.clabe_spei ? "clabe_spei" : null, label: "CLABE SPEI", data: data.space.clabe_spei},
    { key: data.space.cdate ? "cdate" : null, label: "Fecha de apertura", data: moment(data.space.cdate).format('LLL')},
    { key: data.space.pespay && showPespay ? "pespay" : null, label: "Referencia Pespay", data: data.space.pespay},
    { key: data.space.dapp && showDapp ? "dapp" : null, label: "Referencia Dapp", data: data.space.dapp},
    { key: (data.space.type !== "5" && data.space.type !== "7" && showSpace) ? "uuid" : null, label: "Cuenta UUID", data: data.space.uuid },
    { key: data.space.type !== "7" ? "partner" : null, label: "Partner", data: data.space.partner},
  ];

  if(data.space.reasonCancel){
    info.push(
      { key: "reasonCancel_reason", label: "Razón de cancelación", data: data.space.reasonCancel?.reason},
      { key: "reasonCancel_comment", label: "Comentarios", data: data.space.reasonCancel?.comment},
      { key: "reasonCancel_agent_info", label: "Agente", data: data.space.reasonCancel?.agent_info?.name},
    )
  }
  if(data.space.reasonBlock && data.space.reasonBlock.length > 0){
    info.push(
      { key: "reasonBlock_reason", label: "Razón de bloqueo", data: data.space.reasonBlock[0]?.reason},
      { key: "reasonBlock_comment", label: "Comentarios", data: data.space.reasonBlock[0]?.comment ? data.space.reasonBlock[0]?.comment : "N/A"},
      { key: "reasonBlock_agent_info", label: "Agente", data: data.space.reasonBlock[0]?.agent_info?.name},
    )
  }
  
  return (
    <div className="dataBlock">
      {info.map((i) => {
        if(i.key){
          return (
            <div key={i.key} className="dataBlockItem">
              <label style={{width: "21.5%"}} className="neutral">{i.label}</label>
              <p>{i.data}</p>
            </div>
          )
        }
      })}
      {data.space.balance && data.validateVip && 
        <div><hr />
        {Object.keys(data.space.balance).map((i) => {
          const coin: any = { style: 'currency', currency: 'USD' };
          const numberFormat = new Intl.NumberFormat('en-US', coin);
            return (
              <div key={`balance-${i}`} className="dataBlockItem">
                <label style={{width: "21.5%"}} className="neutral">{balance.hasOwnProperty(i) ? balance[i] : "N/A"}</label>
                <p>{numberFormat.format(data.space.balance[i])}</p>
              </div>    
            )          
          })}
        </div> 
      }
    </div>
  );
};

export default SpaceInfo;
